module.exports = __webpack_public_path__ + "static/media/48360945_2309075565834288_3009476793963905024_o.07b2fa80.jpg";